module.exports = __webpack_public_path__ + "static/media/retention_en.fc3d4c49.png";